export default __webpack_public_path__ + "images/3pl-fulfillment-icon.png";